<template>
  <ListeReferentiel
    ref="liste"
    titre="Rôles"
    icone="bi-shield-lock"
    ressource="type_users"
    tri-defaut="tu.nom"
    :options-tri="{ Nom: 'tu.nom', Statut: 'tu.isEnabled' }"
    placeholder="Nom du rôle…"
    unite="rôle(s)"
    vide="Aucun rôle enregistré."
    :colonnes="4"
    :peut-creer="$store.getters.hasPermission('ADMIN_CREER_ROLE')"
    libelle-creer="Nouveau rôle"
    @creer="creation"
  >
    <template #boutons>
      <button v-if="$store.getters.isSuperAdmin" class="btn btn-outline-primary shadow-sm" @click="ouvrirModeles">
        <i class="bi bi-magic me-1"></i>Rôles types
      </button>
    </template>
    <template #entete>
      <th>Nom</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: type }">
      <td>{{ type.nom }}</td>
      <td>
        <span :class="['badge', type.isEnabled ? 'bg-success' : 'bg-secondary']">{{ type.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['ADMIN_MODIFIER_ROLE', 'ADMIN_SUPPRESSION_ROLE'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('ADMIN_MODIFIER_ROLE')"><a class="dropdown-item" href="#" @click.prevent="modifier(type.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('ADMIN_SUPPRESSION_ROLE')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(type)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>

  <!-- Rôles types : ajouter d'un coup ceux qui manquent, avec leurs droits conseillés -->
  <teleport to="body">
    <div v-if="modelesOuverts" class="rt-fond" @mousedown.self="modelesOuverts = false">
      <div class="rt-carte card shadow" role="dialog" aria-modal="true" aria-labelledby="rt-titre">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 id="rt-titre" class="mb-0"><i class="bi bi-magic text-primary me-2"></i>Rôles types</h5>
          <button type="button" class="btn-close" aria-label="Fermer" @click="modelesOuverts = false"></button>
        </div>
        <div class="card-body">
          <p class="small text-muted">
            Chaque rôle type est créé avec les droits conseillés pour ce métier. Vous pourrez ensuite, rôle par rôle,
            cocher ou décocher des droits selon l'organisation de la clinique.
          </p>
          <div v-if="chargementModeles" class="text-center my-3"><div class="spinner-border text-primary"></div></div>
          <div v-for="m in modeles" :key="m.code" class="form-check border rounded p-2 ps-5 mb-2" :class="{ 'bg-light': m.existe }">
            <input :id="'rt-' + m.code" v-model="choisis" class="form-check-input" type="checkbox" :value="m.code" :disabled="m.existe">
            <label :for="'rt-' + m.code" class="form-check-label w-100">
              <span class="fw-semibold">{{ m.nom }}</span>
              <span class="badge ms-1" :class="m.existe ? 'bg-secondary' : 'bg-primary-subtle text-primary-emphasis'">{{ m.existe ? 'Déjà présent' : m.permissions.length + ' droits' }}</span>
              <div class="small text-muted">{{ m.description }}</div>
            </label>
          </div>
          <div v-if="erreurModeles" class="alert alert-danger py-2 small mb-0">{{ erreurModeles }}</div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
          <button type="button" class="btn btn-sm btn-link px-0" :disabled="!manquants.length" @click="choisis = manquants.map(m => m.code)">Tout cocher</button>
          <div>
            <button type="button" class="btn btn-outline-secondary me-2" @click="modelesOuverts = false">Fermer</button>
            <button type="button" class="btn btn-primary" :disabled="!choisis.length || envoiModeles" @click="creerModeles">
              <span v-if="envoiModeles" class="spinner-border spinner-border-sm me-1"></span>Créer {{ choisis.length || '' }} rôle(s)
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';
import api, { messageErreur, notifier } from '@/api';

export default {
  name: 'ListeTypeUser',
  components: { ListeReferentiel },
  data() {
    return { modelesOuverts: false, modeles: [], choisis: [], chargementModeles: false, envoiModeles: false, erreurModeles: '' };
  },
  computed: {
    manquants() { return this.modeles.filter(m => !m.existe); },
  },
  methods: {
    async ouvrirModeles() {
      this.modelesOuverts = true;
      this.erreurModeles = '';
      this.chargementModeles = true;
      try {
        this.modeles = (await api.custom('roles/modeles', 'GET')).data.data || [];
        this.choisis = this.manquants.map(m => m.code);
      } catch (e) {
        this.erreurModeles = messageErreur(e);
      } finally {
        this.chargementModeles = false;
      }
    },
    async creerModeles() {
      this.envoiModeles = true;
      this.erreurModeles = '';
      try {
        const crees = (await api.post('roles/modeles', { codes: this.choisis })).data.crees || [];
        notifier(crees.length ? `Rôles créés : ${crees.join(', ')}. Vérifiez leurs droits, puis attribuez-les aux utilisateurs.` : 'Ces rôles existent déjà.', 'success');
        this.modelesOuverts = false;
        this.$refs.liste.charger();
      } catch (e) {
        this.erreurModeles = messageErreur(e);
      } finally {
        this.envoiModeles = false;
      }
    },
    creation() {
      this.$router.push({ name: 'create_type_users' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_users', params: { id } });
    },
    supprimer(type) {
      this.$refs.liste.supprimer({
        id: type.id,
        titre: 'Supprimer le rôle',
        message: `Supprimer le rôle « ${type.nom} » ? Les utilisateurs qui l'ont perdront ses droits.`,
        succes: 'Rôle supprimé.',
      });
    },
  },
};
</script>

<style scoped>
.rt-fond { position: fixed; inset: 0; background: rgba(15, 23, 42, .45); z-index: 2050; display: flex; align-items: flex-start; justify-content: center; padding: 6vh 16px; overflow-y: auto; }
.rt-carte { width: 100%; max-width: 620px; border-radius: 12px; border: none; }
</style>
